<template>
    <div id="wrapper" class="page" v-if="salary_read">
      <div id="content-wrapper">
        <div class="container-fluid">
          <span style="display: inline;">
            <!-- <button class="btn btn-success mb-2 mr-2" @click.prevent="excelReport">
              <i class="far fa-file-excel"></i> Xuất excel
            </button> -->
            <b-form-select v-model="year_selected" class="mb-2 mr-2" style="width: 10%" :options="optionsYear" value-field="value" text-field="text" @change="queryItem"/>
            <b-form-select  v-model="month_selected" class="mb-2 mr-2" style="width: 10%" :options="optionsMonth" value-field="value" text-field="text" @change="queryItem"/>

          </span>
          <b-table
          bordered
          head-variant="dark"
          hover
          responsive
          striped
          small
          table-variant="light"
          :fields="payrollFields"
          :items="payrolls"
          >
            <template #cell(tenbangluong)="data">Bảng lương đóng BHXH tháng  {{data.item.month}}/{{data.item.year}} - {{ findFirstDepartmentShort(departments, data.item.departmentid) }}</template>
            <template #cell(tong)="data">{{data.item.tong | numeral('0,0')}}</template>
            <template #cell(departmentid)="data"> {{ findFirstDepartment(departments, data.item.departmentid) }}</template>
             <template #cell(excel)="data">
                <b-link
                  class="text-success"
                  href="#"
                  @click="excelReport(data.item.year, data.item.month, data.item.departmentid)"
                >
                  <i class="far fa-file-excel"></i>
                </b-link>
              </template>
          </b-table>
        </div>
      </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SalariesSIPayroll",
  data() {
    return {
      payrollFields :[
        {
          key: "tenbangluong",
          label: "Tên bảng lương",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "260px", textAlign: "center" },
        },
        {
          key: "year",
          label: "Năm",
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "80px", textAlign: "center" },
        },
        {
          key: "month",
          label: "Tháng",
          sortable: true,
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "80px", textAlign: "center" },
        },
        {
          key: "departmentid",
          label: "Đơn vị",
          sortable: true,
          thClass: "align-middle",
           thStyle: { width: "200px", textAlign: "center" },
        },
        {
          key: "tong",
          label: "Tổng lương",
          sortable: true,
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "160px", textAlign: "center" },
        },
        {
          key: "mailsentat",
          label: "Đã gửi email bảng lương",
          sortable: true,
          thClass: "align-middle",
           thStyle: { width: "140px", textAlign: "center" },
        },
         {
          key: "excel",
          label: "Xuất bảng lương",
          tdClass: "text-center",
          thClass: "align-middle",
           thStyle: { width: "100px", textAlign: "center" },
        },

      ],
      query: null,
      salaries: [],
      payrolls: [],
      departments: [],
      year_selected: 0,
      month_selected: 0,
      optionsMonth: [{value: 0, text: "Tất cả"}, {value: 1, text: "Tháng 1"}, {value: 2, text: "Tháng 2"}, {value: 3, text: "Tháng 3"}, {value: 4, text: "Tháng 4"}, {value: 5, text: "Tháng 5"}, {value: 6, text: "Tháng 6"},
                    {value: 7, text: "Tháng 7"}, {value: 8, text: "Tháng 8"}, {value: 9, text: "Tháng 9"}, {value: 10, text: "Tháng 10"}, {value: 11, text: "Tháng 11"}, {value: 12, text: "Tháng 12"},],
    }
  },
  computed: {
    salary_read() {
      return this.$store.getters.hasPermission("salary_read");
    },
    optionsYear() {
      var result = [];
      var this_year = new Date().getFullYear();
      for (var i = 2020; i <= this_year; ++i) {result.push({value: i, text: i});}
      return result;
    },
    is_all_department() {
      return this.$store.state.auth.i == 0;
    }
  },
  beforeRouteEnter(to, from, next) {
      axios
      .all([
          axios.get(`/api/salary/show`),
          axios.get("/api/department"),
      ])
      .then(
          axios.spread((payrolls, departments)=> {
              next((vm) => vm.initData(payrolls.data, departments.data));
          })
      );
  },
  methods:{
    initData(payrolls, departments) {
      this.departments = departments;
      this.payrolls = payrolls;

      this.year_selected = new Date().getFullYear();
      this.month_selected = 0;//parseInt(new Date().getMonth() + 1);
    },
    excelReport(year, month, departmentid) {
      let query = Object.assign({}, this.$route.query);

      // query.year = this.year_selected;
      // query.month = this.month_selected;
      query.year = year;
      query.month = month;
      query.depid = departmentid;
      axios({
        method: "get",
        url: `/api/salary/report3`,
        params: query,
        responseType: "blob", // important
      })
        .then((res) => {
          let filename = res.headers["content-disposition"]
            .split(";")
            .find(function(el) {
              if (el.includes("filename=")) return el;
            })
            .replace("filename=", "")
            .trim();
          const url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.ms-excel;charset=utf-8",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          //   reject(err);
        });
    },

    sendEmail() {
      axios.post("/api/salary/test")
      .then();
      // .catch((err) => {this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
      // })
    },

    queryItem() {
      let query = Object.assign({}, this.$route.query);
      query.q = this.query;
      query.year = this.year_selected;
      query.month = this.month_selected;

      axios.get("/api/salary/show", {params: query})
      .then((res) => {this.payrolls = res.data});
    },

    findFirstDepartment(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.tendonvi;
    },

    findFirstDepartmentShort(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.madonvi;
    }
  },
}
</script>
